import React from 'react';

const IconCompose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21.794" height="21.794" viewBox="0 0 21.794 21.794">
    <path id="circle-plus" d="M14.983,9.875H11.919V6.811a1.014,1.014,0,0,0-.983-1.022,1.08,1.08,0,0,0-1.06,1.022V9.875H6.811a1.022,1.022,0,0,0,0,2.043H9.875v3.065a1.022,1.022,0,1,0,2.043,0V11.919h3.065a1.022,1.022,0,0,0,0-2.043ZM10.9,0a10.9,10.9,0,1,0,10.9,10.9A10.9,10.9,0,0,0,10.9,0Zm0,19.751A8.854,8.854,0,1,1,19.751,10.9,8.864,8.864,0,0,1,10.9,19.751Z" fill="#1d3853" />
  </svg>
);

export default IconCompose;
